import { Input, Modal, message } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./BusinessesModal.scss";
import { getBusinessInfo } from "redux-context/business";
import { useNavigate } from "react-router-dom";
import { getPendingCollabsCount } from "redux-context/collabs";
import { sseService } from "services/SSEStream";
import { getDomainMetadata } from "redux-context/domain";

interface BusinessesModalProps {
  open: boolean;
  onCancel: () => void;
}

const PARTNER_TAG_COLORS = [
  { background: "#E3F2FD", border: "#64B5F6", color: "#0D47A1" },
  { background: "#E8F5E9", border: "#81C784", color: "#1B5E20" },
  { background: "#FFF3E0", border: "#FFB74D", color: "#8A4B00" },
  { background: "#F3E5F5", border: "#BA68C8", color: "#4A148C" },
  { background: "#E0F7FA", border: "#4DD0E1", color: "#006064" },
  { background: "#FCE4EC", border: "#F06292", color: "#880E4F" },
  { background: "#F1F8E9", border: "#AED581", color: "#33691E" },
  { background: "#EDE7F6", border: "#9575CD", color: "#311B92" },
  { background: "#FFFDE7", border: "#DCE775", color: "#827717" },
  { background: "#EFEBE9", border: "#A1887F", color: "#3E2723" },
];

const getPartnerTagStyle = (partner: string): React.CSSProperties => {
  const colorIndex =
    partner
      .split("")
      .reduce((sum, character) => sum + character.charCodeAt(0), 0) %
    PARTNER_TAG_COLORS.length;

  return PARTNER_TAG_COLORS[colorIndex];
};

const BusinessesModal: React.FC<BusinessesModalProps> = (props) => {
  const { open, onCancel } = props;
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const { businessess } = useSelector((state: any) => state.business);
  const [filterName, setFilterName] = useState<string>("");
  const [filteredBusinesses, setFilteredBusinesses] = useState<any[]>([]);
  const [selectedBusiness, setSelectedBusiness] = useState<string>(
    localStorage.getItem("businessId") || "",
  );

  const onClickOk = () => {
    if (!selectedBusiness)
      message.error("This business has no ID, please contact support.");
    localStorage.setItem("businessId", selectedBusiness);
    dispatch(getBusinessInfo());
    dispatch(getDomainMetadata());
    dispatch(getPendingCollabsCount());
    onCancel();
    setFilterName("");
    navigate(".", { replace: true });
    window.location.reload();
    sseService.reload();
  };

  useEffect(() => {
    setFilteredBusinesses(
      businessess?.filter((business: any) =>
        business.name.toLowerCase().includes(filterName.toLowerCase()),
      ),
    );
  }, [filterName, businessess]);

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      onOk={onClickOk}
      title="Select your profile"
      className="businesses-modal"
    >
      <Input
        value={filterName}
        onChange={(event) => setFilterName(event.target.value)}
        placeholder="Search profile"
      />
      <div className="businesses">
        {filteredBusinesses?.map((business: any, index: number) => (
          <div
            key={`${business?.businessId}_${index}`}
            className={`business-item ${
              business?.businessId === selectedBusiness && "selected"
            } `}
            onClick={() => setSelectedBusiness(business?.businessId)}
          >
            <span className="business-name">
              {business?.partner ? (
                <span
                  className="partner-tag"
                  style={getPartnerTagStyle(business.partner)}
                >
                  {business.partner}
                </span>
              ) : null}
              {business?.name}
            </span>
            <span>{business?.address}</span>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default BusinessesModal;
